import React from 'react';
import Error from './Error';
import Success from './Success';
const Messages = (props) => {
    switch (props.type) {
        case 'error':
            return React.createElement(Error, { style: props.style, messages: props.messages });
        case 'success':
            return React.createElement(Success, { style: props.style, messages: props.messages });
        default:
            return React.createElement(Success, { style: props.style, messages: props.messages });
    }
};
export default Messages;
//# sourceMappingURL=Messages.js.map